export default __webpack_public_path__ + "static/media/hero.20dae0f8.png";